import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, CircularProgress, Dialog } from '@material-ui/core';




const styles = theme => ({


});



class LoadingIcon extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading_state_iocn: true,


        };
    }


    render() {
        const { classes } = this.props;

        return (

            <div>
                <Dialog
                    open={this.state.loading_state_iocn}
                >
                    <div className="centerloadingicon" style={{ top: '50%' }} >
                        <CircularProgress />

                    </div>

                </Dialog>

            </div>
        )
    }


}
LoadingIcon.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoadingIcon);